export default __webpack_public_path__ + "static/binoculars-with-green-dots-8b63d9fc0481191c1540812996fcb7db.svg";